import i18n from "i18n";

export const getOffers = () => [
  {
    name: i18n.t("careerSection.jobs.projectManager"),
    city: "WROCŁAW",
    link: "https://www.pracuj.pl/praca/project-manager-budownictwo-wroclaw,oferta,1003248008",
  },
  {
    name: i18n.t("careerSection.jobs.projectManager"),
    city: `WROCŁAW\n${i18n.t("careerSection.locations.germany")}`,
    link: "https://www.pracuj.pl/praca/project-manager-ds-lokalizacji-i-budowy-z-jezykiem-niemieckim-wroclaw,oferta,1003275789",
  },
  {
    name: i18n.t("careerSection.jobs.realEstateAcquisitionSpecialist"),
    city: `WROCŁAW\n${i18n.t("careerSection.locations.germany")}`,
    link: "https://www.pracuj.pl/praca/specjalista-specjalistka-ds-pozyskiwania-nieruchomosci-wroclaw,oferta,1003290898?s=74c4d155&searchId=MTcxMzQ1NjU5MDY3NC41MjM=",
  },
];
